/* eslint-disable */
// 姓名
export const userName = {
	getMessage: field => field + "不正确",
	validate: (value, args) => {
		return /^[\u4E00-\u9FA5]+$/.test(value)
	}
}
// 手机号
export const phone = {
	getMessage: field => field + "不正确",
	validate: (value, args) => {
		return /^1\d{10}$/.test(value)
	}
};